module.exports = __webpack_public_path__ + "img/auth-left-angle.e4613a2e.svg";